// Footer newsletter — wires the <form> to the Klaviyo bulk-subscribe
// PHP handler (sentiments_newsletter_subscribe) via admin-ajax.php.
//
// State machine on `.sentiments-footer__form`:
//   idle   → user typing
//   .is-loading  → submit clicked, fetch in flight (button disabled, spinner)
//   .is-success  → 2xx from Klaviyo (form replaced by message)
//   .is-error    → validation / API / network error (inline message; form stays)
//
// AJAX URL + nonce come from window.sentimentsNewsletter, localized by
// PHP onto the bundled `sentiments-motion` script.

export function initFooterNewsletter() {
	const form        = document.querySelector('.sentiments-footer__form');
	const message     = document.querySelector('.sentiments-footer__form-message');
	const successBox  = document.querySelector('.sentiments-footer__form-success');
	const successText = document.querySelector('.sentiments-footer__form-success-text');
	const resetBtn    = document.querySelector('.sentiments-footer__form-success-reset');
	const emailInput  = form?.querySelector('input[type="email"]');
	if (!form || !message || !successBox || !successText) return;

	const config = window.sentimentsNewsletter;
	if (!config || !config.ajax || !config.nonce) {
		// PHP didn't localize — silently bail rather than break the form.
		return;
	}

	const setState = (state, text = '') => {
		form.classList.remove('is-loading', 'is-success', 'is-error');
		if (state) form.classList.add(`is-${state}`);

		if (state === 'success') {
			successText.textContent = text || 'Thanks — check your inbox to confirm.';
			successBox.hidden = false;
			message.textContent = ''; // success box owns the messaging now
		} else {
			successBox.hidden = true;
			message.textContent = state === 'error' ? text : '';
		}
	};

	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		if (form.classList.contains('is-loading') || form.classList.contains('is-success')) return;

		const data = new FormData(form);
		data.append('action', 'sentiments_newsletter_subscribe');
		data.append('nonce', config.nonce);

		setState('loading');

		try {
			const res = await fetch(config.ajax, { method: 'POST', body: data, credentials: 'same-origin' });
			const json = await res.json().catch(() => ({ ok: false, message: 'Unexpected response.' }));

			if (json.ok) {
				setState('success', json.message);
			} else {
				setState('error', json.message || 'Something went wrong. Please try again.');
			}
		} catch (err) {
			setState('error', 'Network error — please try again.');
		}
	});

	// Reset button — drops the success state, clears the input, focuses it
	// so a second submission can happen with a single tap.
	resetBtn?.addEventListener('click', () => {
		setState(null);
		form.reset();
		emailInput?.focus();
	});
}
